"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundModule = void 0;
const react_1 = require("react");
const React = require("react");
require("./not-found.less");
class NotFoundModule extends react_1.Component {
    render() {
        return (React.createElement("div", { className: "notfound__wrapper" },
            React.createElement("p", { className: "notfound__text--header" }, "404"),
            React.createElement("p", { className: "notfound__text--subheader" }, "Page Not Found")));
    }
}
exports.NotFoundModule = NotFoundModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/not-found/not-found.tsx
// module id = 2430
// module chunks = 0 1 2